module.exports = "//static.hsappstatic.net/connect-dot-com-ui/static-1.384/html/third-party-cookie-test.html"